export enum ConsentWrapperStage {
  General = 'general',
  Details = 'details',
}

export enum ConsentButtonsTheme {
  SameFilled = 'same_filled',
  Highlighted = 'highlighted',
}
